// extracted by mini-css-extract-plugin
export var starRating = "ArticleStarRating-module--starRating--2CHQN";
export var svgElement = "ArticleStarRating-module--svgElement--3UMyK";
export var svgStar = "ArticleStarRating-module--svgStar--1mKRe";
export var starFilled = "ArticleStarRating-module--starFilled--1oQNc";